import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear admin token/session (adjust according to your auth)
    localStorage.removeItem("adminToken"); 
    // Redirect to login page
    navigate("/platformadmin-login");
  }, [navigate]);

  return null; // nothing to render
};

export default Logout;
